<template>
  <div>
    <section>
      <div
        class="d-flex justify-content-center align-items-center showcase text-white"
      >
        <div class="showcase-content text-center">
          <h3 class="mb-3">
            Join a community of successful graduates with our practical,
            hands-on training programs designed to give you the competitive edge
            needed for your tech career goals
          </h3>
          <div class="d-flex justify-content-center align-items-center">
            <router-link to="#" class="btn btn-outline-light"
              >Get Started</router-link
            >
          </div>
        </div>
      </div>
    </section>
    <section class="py-5 reviews-section">
      <div class="container">
        <div class="">
          <h3 class="text-center py-4 fw-bold">Partners</h3>
          <swiper
            :breakpoints="{
              '425': {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              '768': {
                slidesPerView: 4,
                spaceBetween: 40,
              },
              '1024': {
                slidesPerView: 7,
                spaceBetween: 50,
              },
            }"
            :spaceBetween="40"
            :autoplay="{
              delay: 2500,
              disableOnInteraction: false,
            }"
            :pagination="{
              clickable: true,
            }"
            :navigation="true"
            :modules="modules"
          >
            <swiper-slide v-for="review in 8" :key="review.id">
              <img
                src="../../assets/Images/home/partner.png"
                class="img-fluid"
                alt=""
              />
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </section>
  </div>
</template>
      
      <script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper.min.css";
import { Autoplay, Pagination, Navigation } from "swiper";
import "swiper/css/navigation";
export default {
  name: "Arduino",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      reviews: [
        {
          id: 1,
          review: "kompletecare-cover.png",
          name: "Obot Ekanem",
          title: "CEO Obed Digital",
          image_src: "review.png",
        },
        {
          id: 2,
          review: "kompletecare-cover.png",
          name: "Obot Ekanem",
          title: "CEO Obed Digital",
          image_src: "review.png",
        },
        {
          id: 3,
          review: "kompletecare-cover.png",
          name: "Obot Ekanem",
          title: "CEO Obed Digital",
          image_src: "review.png",
        },
      ],
    };
  },
  setup() {
    return {
      modules: [Autoplay, Pagination, Navigation],
    };
  },
};
</script>
      
      <style scoped>
.products-section {
  background: #d8e2f3;
}
.learn-slider {
  width: 70% !important;
  margin: 0 auto;
}

.learn-image {
  height: 400px;
}

.product-img {
  height: 420px;
}

.testifier {
  height: 72px;
  width: 72px !important;
  border-radius: 50%;
}

.testimony-card {
  width: 70%;
  margin: 0 auto;
}

.showcase {
  height: 360px;
  background-image: url("../../assets/Images/knowus.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-blend-mode: darken;
  background-color: rgba(0, 0, 0, 0.1);
}

.showcase-content {
  width: 50%;
}

.swiper-container {
  width: 100%;
  height: 300px;
}

.swiper-slide {
  display: block;
}

.image-box {
  margin: 10px;
}

.swiper-slide img {
  display: block;
  width: 100%;
}

.swiper {
  padding: 0 40px;
}

.swiper-button-prev,
.swiper-button-next {
  position: absolute;
  top: 50% !important;
  width: 27px;
  height: 44px;
  margin-top: -22px !important;
  z-index: 1000;
  cursor: pointer;
  /* background-size: 27px 44px;
  background-position: center;
  background-repeat: no-repeat; */
}

.swiper-button-prev {
  left: 0px;
  /* background-image: url('../../assets/Images/home/arrow-left.png'); */
}

.swiper-button-next {
  right: 0px;
  /* background-image: url('../../assets/Images/home/arrow-right.png'); */
}

@media (max-width: 769px) {
  .showcase-content {
    width: 85%;
  }
}
</style>
      